module.exports = __webpack_public_path__ + "static/media/me.3d3c4f1f.jpg";